import {TimelineLite, TweenLite} from "gsap";
import {MathHelper} from "../../../../core/utils/MathHelper";
import {Layers, TheRaveLayers} from "../../../view/TheRaveLayers";
import {FontStyleConfig} from "../../../config/FontConfig";
import {BitmapCountUp} from "../../../coutup/BitmapCountUp";
import {TheRaveSound} from "../../../sound/TheRaveSound";
import {TheRave} from "../../../TheRave";

export class InitialWinCountUp extends PIXI.Container {

    protected _countUp: BitmapCountUp;
    private _endingScale: number = 0.6;

    constructor() {
        super();

        const style = FontStyleConfig.COUNT_UP_INITIAL_WIN;
        this._countUp = new BitmapCountUp(style, {}, "InitialWinCountUp");
        //this._countUp.shrinkSize = true;
        this._countUp.visible = false;
        this.addChild(this._countUp);
        this._countUp.anchor = 0.5;
        this.position.set(360, 419);
        TheRaveLayers.getLayer(Layers.WIN_COUNT_UP)?.addChild(this);
    }

    public getCountUpAnimation(from: number, to: number, duration: number, multiplier: number): TimelineLite {
        const baseToNumber = multiplier === 1 ? to : MathHelper.roundToDecimals(to / multiplier, 2);
        const tl = new TimelineLite();
        tl.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(from, baseToNumber, {duration: duration, ease: `power3.inOut`})
        ], 0.2);
        if(!TheRave.isWinBelowStake()){
            tl.add(() => {TheRaveSound.playNormalWinSound(TheRave.model.parsedGameData.currentWinRatioConfig!);});
        }
        // ending stay
        tl.add(this.stay(multiplier));

        return tl;
    }

    private stay(multiplier: number): TimelineLite {
        const tl = new TimelineLite();
        tl.add(()=>{
            this._countUp.showValue(TheRave.model.parsedGameData.singleWin);
        });
        tl.add(()=>{},1);
        //tl.add(() =>.soundPlayer.playTrack({name : ElPasoGunfightSoundConfig.instance.COUNT_UP_END_FALL_BACK}), "-=0.3");
        return tl;
    }

    public remove(): TimelineLite {
        const tl = new TimelineLite();
        if (this._countUp.visible) {
            tl.add(TweenLite.to(this._countUp, {duration: 0.5, alpha: 0, y: -100, ease: `power2.in`}), `+=0.2`); // stay a short while after count up.
            tl.add(() => {
                this._countUp.y = 0;
                this._countUp.visible = false;
            });
        }

        return tl;
    }

    public onOrientationChanged(): void {
        if (!this._countUp.visible) {
            return;
        }

        this._countUp.updateCountUpTextPivot();
    }

    public setColor(color: number): void {
        this._countUp.tint = color;
    }
}